var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__a)",
    stroke: "#D9DEDF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 .75V4.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m19.955 4.045-2.652 2.652"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.25 12H19.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m19.955 19.955-2.652-2.652"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12 23.25V19.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m4.045 19.955 2.652-2.652"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M.75 12H4.5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m4.045 4.045 2.652 2.652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLoading;